import React, { useState } from "react";
import { Button } from "primereact/button";
import { apiService } from "../../services/apiService";
import { useToast } from "../../contexts/ToastContext";

const WeeksAdmin: React.FC = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const toast = useToast();

  const handleGenerateWeeks = async () => {
    try {
      setIsGenerating(true);

      const response = await apiService.generateWeeks();

      if (response.success) {
        toast.showSuccess(
          "Weeks Generated",
          "Weeks have been successfully generated for the current year and the next two years"
        );
      } else {
        toast.showError("Error", "Failed to generate weeks");
      }
    } catch (error) {
      console.error("Failed to generate weeks:", error);
      toast.showError("Error", "Failed to generate weeks");
    } finally {
      setIsGenerating(false);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <div>
      <div className="flex flex-column gap-4">
        <div className="text-center">
          <div className="mb-4">
            <h3 className="mt-0 mb-2">Generate Weeks</h3>
            <p className="text-600 mb-4">
              Generate weeks in the database for the current year ({currentYear}
              ) and the next two years ({currentYear + 1}, {currentYear + 2}).
            </p>
            <p className="text-500 text-sm">
              This operation will create all necessary week records for proper
              scheduling functionality.
            </p>
          </div>

          <Button
            label="Generate Weeks"
            icon="pi pi-calendar-plus"
            size="large"
            loading={isGenerating}
            disabled={isGenerating}
            onClick={handleGenerateWeeks}
            className="p-button-success"
          />
        </div>
      </div>
    </div>
  );
};

export default WeeksAdmin;
